import { configureStore } from '@reduxjs/toolkit'
import lmleadsData from '../reducers/index'

export default function initStore(initialState) {
    const store = configureStore({
        reducer: lmleadsData,
        preloadedState: initialState,
        devTools: false
    })

    return store
}
